export const ROULETTE_STATISTIC = "ROULETTE_STATISTIC";
export const ROULETTE_REQUEST_FETCH_DRAWING_RESULT = "ROULETTE_REQUEST_FETCH_DRAWING_RESULT";
export const ROULETTE_REQUEST_FETCH_RECENT_DRAW = "ROULETTE_REQUEST_FETCH_RECENT_DRAW";
export const ROULETTE_REQUEST_FETCH_RECENT_BET_REPORT = "ROULETTE_REQUEST_FETCH_RECENT_BET_REPORT";
export const ROULETTE_LIST_BETTING = 'ROULETTE_LIST_BETTING';
export const ROULETTE_FETCH_RESULT_REPORT = "ROULETTE_FETCH_RESULT_REPORT";
export const ROULETTE_FETCH_WIN_LOSS_REPORT = "ROULETTE_FETCH_WIN_LOSS_REPORT";

export const ROULETTE_FETCH_DRAWING_REQUEST = "ROULETTE_FETCH_DRAWING_REQUEST";
export const ROULETTE_FETCH_DRAWING_SUCCESS = "ROULETTE_FETCH_DRAWING_SUCCESS";
export const ROULETTE_FETCH_DRAWING_FAILURE = "ROULETTE_FETCH_DRAWING_FAILURE";
export const ROULETTE_CLEAR_DRAWING_ERROR = "ROULETTE_CLEAR_DRAWING_ERROR";


export const ROULETTE_FETCH_RECENT_DRAW_REQUEST = "ROULETTE_FETCH_RECENT_DRAW_REQUEST";
export const ROULETTE_FETCH_RECENT_DRAW_SUCCESS = "ROULETTE_FETCH_RECENT_DRAW_SUCCESS";
export const ROULETTE_FETCH_RECENT_DRAW_FAILURE = "ROULETTE_FETCH_RECENT_DRAW_FAILURE";